import {
  UnmanagedBusinessAutoRegisterConditionFieldType,
  UnmanagedBusinessAutoRegisterField,
} from '@/coreDomainsModule/constants/unmanagedBusinessAutoRegister';

/**
 * 自動登録条件で必須にする6KEY項目
 */
export const requiredConditionFieldTypes: UnmanagedBusinessAutoRegisterConditionFieldType[] = [
  'warehouse',
  'supplier',
  'business',
  'package',
  'customer',
  'salesDestination',
];

/**
 * 自動登録時に選択可能な任意登録項目
 */
export const optionalRegisterFields: UnmanagedBusinessAutoRegisterField[] = [
  'unit',
  'manufacturer',
  'endUser',
  'orderPackage',
  'moq',
  'forecastForReceiptMemo',
  'purchaseUnitPrice',
  'salesUnitPrice',
];

/**
 * 任意登録項目のうち数値バリデーション対象となる項目
 */
export const numericOptionalRegisterFields = new Set<UnmanagedBusinessAutoRegisterField>([
  'orderPackage',
  'moq',
  'purchaseUnitPrice',
  'salesUnitPrice',
]);
